import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the pickups state domain
 */

const selectPickupsDomain = (state) => state.pickups || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Pickups
 */

const makeSelectPickups = createSelector(
  selectPickupsDomain,
  (substate) => substate.data || []
);

const makeSelectUpcomingPickups = createSelector(
  makeSelectPickups,
  (substate) =>
    substate
      .filter((pickup) => pickup.pickupStatus.label === "Pending")
      .reverse() || null
);
const makeSelectPastPickups = createSelector(
  makeSelectPickups,
  (substate) =>
    substate
      .filter((pickup) => pickup.pickupStatus.label !== "Pending")
      .reverse() || null
);

const makeSelectCompletedPickups = createSelector(
  makeSelectPickups,
  (substate) =>
    substate
      .filter((pickup) => pickup.pickupStatus.label === "Complete")
      .reverse() || null
);

export default makeSelectPickups;
export {
  selectPickupsDomain,
  makeSelectUpcomingPickups,
  makeSelectPastPickups,
  makeSelectCompletedPickups,
};
